import * as React from "react"
export const Svg_074 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M58 11.134V5.948H17.284l-2.353 5.186H58Z" />
    <path
      fill="url(#b)"
      d="M11.326 42.276v.981h9.049v-.981c0-1.37-1.096-2.485-2.443-2.485h-4.163c-1.347 0-2.443 1.115-2.443 2.485Z"
    />
    <path
      fill="url(#c)"
      d="M0 53.052h58V14.59H0v38.46Zm50.072-6.338H32.398v-3.457h17.674v3.457Zm0-6.914H32.398v-3.457h17.674v3.456Zm0-6.915H32.398v-3.457h17.674v3.457ZM15.85 20.946h26.3v3.457h-26.3v-3.457Zm-4.696 16.017a5.49 5.49 0 0 1-.662-2.623v-1.03c0-3.005 2.404-5.45 5.358-5.45 2.955 0 5.359 2.445 5.359 5.45v1.03c0 .95-.24 1.844-.662 2.623a5.96 5.96 0 0 1 3.226 5.313v4.438H7.928v-4.438a5.96 5.96 0 0 1 3.226-5.313Z"
    />
    <path fill="url(#d)" d="M13.54 5.948H0v5.186h11.188l2.353-5.186Z" />
    <path
      fill="url(#e)"
      d="M15.85 36.334c1.081 0 1.96-.895 1.96-1.994v-1.03c0-1.098-.879-1.993-1.96-1.993-1.08 0-1.96.895-1.96 1.994v1.03c0 1.098.88 1.993 1.96 1.993Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={24.891}
        x2={25.298}
        y1={6.726}
        y2={12.204}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={13.419}
        x2={14.244}
        y1={40.311}
        y2={43.797}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={13.412}
        x2={27.746}
        y1={20.36}
        y2={55.342}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={3.131}
        x2={4.366}
        y1={6.726}
        y2={11.942}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={14.797}
        x2={17.39}
        y1={32.07}
        y2={35.349}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)